import { useMemo } from "react"
import { chain } from "lodash"
import { NUMERIC_AND_EXISTENCE_OPERATORS } from "helpers/filters/filter-ons/existence"
import { useContentSetsMetadata } from "resources/content-sets"
import type { FilterOn } from "helpers/filters/filter-ons"
import { DataStatus } from "helpers/data-statuses"

interface ContentSet {
  id: string
  name: string
  factors: {
    id: string
    name: string
    category: string
  }[]
  categories: {
    id: string
    name: string
  }[]
}

export function useContentSetFilters(): [FilterOn[], DataStatus] {
  const [contentSets, contentSetsStatus] = useContentSetsMetadata()

  const filters = useMemo(() => {
    if (!contentSets) {
      return []
    }

    const filters: FilterOn[] = contentSets.flatMap((contentSet: ContentSet) => {
      const contentSetFilters: FilterOn[] = contentSet.categories.map(contentSetCategory => ({
        label: `${contentSet.name} ${contentSetCategory.name} Exposure`,
        type: "factorExposure" as const,
        options: chain(contentSet.factors)
          .pickBy(({ category }) => category === contentSetCategory.id)
          .map(({ name, id }) => ({
            label: `${name} Exposure`,
            type: "factorExposure" as const,
            dataType: "numeric" as const,
            operators: NUMERIC_AND_EXISTENCE_OPERATORS,
            value: id,
            contentSetId: contentSet.id,
          }))
          .value(),
      }))
      return contentSetFilters
    })
    return filters
  }, [contentSets])

  return [filters, contentSetsStatus]
}
